import { Controller } from "@hotwired/stimulus"

// Fallback for a dropped WebSocket: periodically fetches the live regions as a
// Turbo Stream and applies them. Idempotent — the board/stats controllers only
// animate real state changes, so an identical re-render is invisible.
export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 3000 } }

  connect() {
    this.timer = setInterval(() => this.sync(), this.intervalValue)
    this.onVisible = () => { if (document.visibilityState === "visible") this.sync() }
    document.addEventListener("visibilitychange", this.onVisible)
  }

  disconnect() {
    clearInterval(this.timer)
    document.removeEventListener("visibilitychange", this.onVisible)
  }

  async sync() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        credentials: "same-origin"
      })
      if (response.ok && window.Turbo) window.Turbo.renderStreamMessage(await response.text())
    } catch {
      // Offline or navigating away: the next tick will try again.
    }
  }
}
